






























import Vue from 'vue';

import ReviewCardItem from './review-card-item.vue';

export default Vue.extend({
  name: 'ReviewCards',

  components: {
    ReviewCardItem,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    reviews: {
      type: Array,
      default: () => [],
    },

    rows: {
      type: Boolean,
      default: true,
    },
  },

  created() {
    console.log(this.reviews);
  },
});
